import { SCOPE_KEYS } from '../../domain/access';
import type {
  CommonFiltersInput,
  DashboardRateInput,
  PageableRangeInput,
  RangeInput,
} from '../../types/extranet-api.types';

/**
 * Filtres du header → contrat back :
 * - `scopes[key]` → `key[]` (les 5 dimensions de périmètre, tableau par clé)
 * - `dateRange.{from,to}` ISO → `startDate` / `endDate` timestamps ms
 */
export const toFiltersInput = (filters: DashboardRateInput): CommonFiltersInput => {
  const input: CommonFiltersInput = {};
  for (const key of SCOPE_KEYS) {
    const values = filters.scopes?.[key];
    if (values?.length) input[key] = values;
  }
  return input;
};

export const toRateInput = (filters: DashboardRateInput): RangeInput => ({
  ...toFiltersInput(filters),
  startDate: new Date(filters.dateRange.from).getTime(),
  endDate: new Date(filters.dateRange.to).getTime(),
});

export const toPageableRangeInput = (
  filters: DashboardRateInput,
  page?: { offset?: number; limit?: number },
): PageableRangeInput => ({
  ...toRateInput(filters),
  offset: page?.offset,
  limit: page?.limit,
});
